export const scrollToElement = (ref: any, block?: string, behavior?: string) =>
  ref?.current?.scrollIntoView({
    block: block || "center",
    behavior: behavior || "smooth",
  })
